import { useEffect } from "react";

import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import Modal from "./Modal";
import useSkuListing from "../../hooks/useSkuListing";

const LocationListingsModal = ({ open, onClose, clientId, locationId }) => {
  const { client, listingData, loading, fetchListingsForLocation } =
    useSkuListing();

  useEffect(() => {
    if (!open || !clientId || !locationId) return;
    fetchListingsForLocation(clientId, locationId);
  }, [open, clientId, locationId]);

  const getListedValue = (listing) => {
    if (!listing?.listing?.listings) return "-";

    if (listing.listing.listings.national === 1) return "Yes";
    if (listing.listing.listings.national === 0) return "No";

    return "-";
  };

  return (
    <Modal
      title="Listings"
      subTitle={client?.name || ""}
      open={open}
      onClose={onClose}
      width="950px"
      height="620px"
      contentOverflow="auto"
    >
      <Box sx={{ padding: "12px" }}>
        <Typography sx={{ fontSize: "12px", marginBottom: "8px" }}>
          Location ID: {locationId}
        </Typography>

        {loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center", padding: "24px" }}
          >
            <CircularProgress size={24} />
          </Box>
        ) : Array.isArray(listingData) && listingData.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>SKU</TableCell>
                <TableCell>SKU ID</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Listed</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listingData.map((item) => (
                <TableRow key={`${item.id}-${item.skuId}`}>
                  <TableCell>{item.name || "-"}</TableCell>
                  <TableCell>{item.skuId || "-"}</TableCell>
                  <TableCell>{item.locationName || "-"}</TableCell>
                  <TableCell>{getListedValue(item)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No applicable listings found.</Typography>
        )}
      </Box>
    </Modal>
  );
};

export default LocationListingsModal;
